//libs
import {useCallback} from 'react';
import {useAlert} from 'react-alert';

//components
import Select from './select';

//hooks
import {useConfirmLocation} from '../../../../util/misc';

//types
import {INewIekLocationFilters} from '../types/INewIekLocationFilters';

const mapToOptions = (list: string[]) => list.map((name) => ({name, value: name}));
const multilineText = (text: string) => text.split('\n').map((s, idx) => <p key={idx}>{s}</p>);

export default function NewIekLocationFilters({
                                                  country,
                                                  region,
                                                  city,
                                                  countries,
                                                  regions,
                                                  cities,
                                                  setCountry,
                                                  setRegion,
                                                  setCity,
                                              }: INewIekLocationFilters) {
    const alert = useAlert();
    const alertMissing = useCallback(
        (text) => {
            const alertInstance = alert.show(multilineText(text), {
                // @ts-ignore
                title: 'Location not determined',
                actions: [{name: 'OK', onClick: () => alertInstance.close()}],
                type: 'error',
            });
        },
        [alert]
    );
    const confirmLocation = useCallback(
        (text: string, callback: () => void) => {
            const alertInstance = alert.show(multilineText(text), {
                // @ts-ignore
                title: 'Your location',
                actions: [
                    {
                        name: 'Yes',
                        onClick: () => {
                            callback();
                            alertInstance.close();
                        },
                    },
                    {
                        name: 'No',
                        className: 'ui-button--gray',
                        onClick: () => alertInstance.close(),
                    },
                ],
            });
        },
        [alert]
    );

    useConfirmLocation(alertMissing, confirmLocation);

    return (
        <>
            <div className="partners-select-item">
                <Select
                    name="Country"
                    value={country}
                    options={mapToOptions(countries)}
                    onChange={(v) => setCountry(v || '')}
                />
            </div>
            <div className="partners-select-item">
                <Select
                    name="Region"
                    value={region}
                    options={mapToOptions(regions)}
                    onChange={(v) => setRegion(v || '')}
                />
            </div>
            <div className="partners-select-item">
                <Select
                    name="City"
                    value={city}
                    options={mapToOptions(cities)}
                    onChange={(v) => setCity(v || '')}
                />
            </div>
        </>
    );
}